import { injuryConstants } from '../constants';

const mapInjuryTypeToText = (injuryTypeId) => {
  let list = injuryConstants.injuryTypes;
  let selectedInjuryType = list.filter((i) => i.id === injuryTypeId)[0];
  if (selectedInjuryType) {
    return selectedInjuryType.value;
  }
  return 'Unknown';
};

export default { mapInjuryTypeToText };
